/* ARTEFOÁ DERMOCOSMÉTICOS — theme.js */

document.addEventListener('DOMContentLoaded', function () {

  /* ── MOBILE MENU ─────────────────────────── */
  const toggle = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  /* ── ANNOUNCEMENT SLIDER (if multiple) ───── */
  const msgs = document.querySelectorAll('.announcement-bar__msg');
  if (msgs.length > 1) {
    let idx = 0;
    msgs.forEach((m, i) => m.style.display = i === 0 ? 'flex' : 'none');
    setInterval(() => {
      msgs[idx].style.display = 'none';
      idx = (idx + 1) % msgs.length;
      msgs[idx].style.display = 'flex';
    }, 4000);
  }

  /* ── CART DRAWER ─────────────────────────── */
  const cartBtns = document.querySelectorAll('[data-cart-open]');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartClose  = document.querySelector('[data-cart-close]');
  const cartOverlay = document.getElementById('cart-overlay');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }
  cartBtns.forEach(b => b.addEventListener('click', openCart));
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ── ADD TO CART ─────────────────────────── */
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const data = new FormData(form);
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: data });
      if (!res.ok) throw new Error('Cart add failed');
      await updateCart();
      openCart();
    } catch (err) {
      console.error(err);
    }
  });

  async function updateCart() {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    const count = document.querySelectorAll('.cart-count__bubble');
    count.forEach(el => { el.textContent = cart.item_count; });
    const drawerItems = document.getElementById('cart-drawer-items');
    if (drawerItems) renderCartItems(cart, drawerItems);
  }

  function renderCartItems(cart, container) {
    if (cart.item_count === 0) {
      container.innerHTML = '<p style="padding:24px;color:#AFAFAF;font-size:13px;">Seu carrinho está vazio.</p>';
      return;
    }
    container.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <img src="${item.image}" alt="${item.title}" class="cart-item__img">
        <div class="cart-item__info">
          <div class="cart-item__name">${item.product_title}</div>
          <div class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div class="cart-item__price">R$ ${(item.final_price / 100).toFixed(2).replace('.', ',')}</div>
        </div>
        <button class="cart-item__remove" data-line="${item.key}" aria-label="Remover">×</button>
      </div>
    `).join('');
    container.querySelectorAll('[data-line]').forEach(btn => {
      btn.addEventListener('click', () => removeFromCart(btn.dataset.line));
    });
  }

  async function removeFromCart(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    updateCart();
  }

  updateCart();

  /* ── PRODUCT IMAGE GALLERY ───────────────── */
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImg = document.getElementById('product-main-image');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      if (mainImg) mainImg.src = this.dataset.src;
      thumbs.forEach(t => t.classList.remove('is-active'));
      this.classList.add('is-active');
    });
  });

  /* ── STICKY HEADER SHADOW ────────────────── */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.borderBottomColor = window.scrollY > 10 ? '#D8D8D8' : '#D8D8D8';
    }, { passive: true });
  }

});
